import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Plus } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { gapi, errMsg, fmtEuro, fmtDate } from "../api";
import { useGAuth } from "../GAuth";
import { PageHeader, Panel, Btn, Badge, inputCls } from "../components/ui";
import { Field, ContactPicker } from "../components/common";

export const VAL_TONE = { bozza: "amber", revisionata: "blue", finalizzata: "green" };

function NewDialog({ open, onClose }) {
  const navigate = useNavigate();
  const [mode, setMode] = useState("immobile");
  const [props, setProps] = useState([]);
  const [pid, setPid] = useState("");
  const [owner, setOwner] = useState(null);
  useEffect(() => { if (open) gapi.get("/properties", { params: { size: 100 } }).then((r) => setProps(r.data.items)).catch(() => {}); }, [open]);
  const go = async () => {
    try { const { data } = await gapi.post("/valuations", mode === "immobile" ? { propertyId: pid } : { proprietarioId: owner?.id }); navigate(`/gestionale/valutazioni/${data.id}`); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-lg" data-testid="val-new-dialog">
        <DialogHeader><DialogTitle>Nuova valutazione</DialogTitle><DialogDescription>Preparata nell'area riservata: nessun modulo pubblico.</DialogDescription></DialogHeader>
        <div className="flex gap-2 text-xs">{[["immobile", "Da un immobile esistente"], ["nuovo", "Nuova scheda collegata al proprietario"]].map(([k, l]) => (
          <button key={k} onClick={() => setMode(k)} className={`rounded-full px-3 py-1.5 font-semibold border ${mode === k ? "bg-brand text-white border-brand" : "border-border-subtle"}`} data-testid={`val-new-mode-${k}`}>{l}</button>))}</div>
        {mode === "immobile" ? <select className={inputCls} value={pid} onChange={(e) => setPid(e.target.value)} data-testid="val-new-property"><option value="">Seleziona immobile…</option>{props.map((p) => <option key={p.id} value={p.id}>{`${p.codiceRif} · ${p.titolo}`}</option>)}</select>
          : <Field label="Proprietario (facoltativo)"><ContactPicker value={owner} onChange={setOwner} testid="val-new-owner" /></Field>}
        <Btn onClick={go} disabled={mode === "immobile" && !pid} data-testid="val-new-create">Crea valutazione</Btn>
      </DialogContent>
    </Dialog>
  );
}

export default function Valutazioni() {
  const { can } = useGAuth();
  const [list, setList] = useState(null);
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  useEffect(() => { const t = setTimeout(() => gapi.get("/valuations", { params: { q } }).then((r) => setList(r.data)), 250); return () => clearTimeout(t); }, [q]);
  return (
    <div data-testid="g-valuations-page">
      <PageHeader eyebrow="Valutazioni" title="Valutazioni e brochure" desc="Stime documentate con comparabili, calcolo trasparente, valori finali dell'agente e brochure PDF per il proprietario."
        actions={can("valutazioni", "creare") && <Btn onClick={() => setOpen(true)} data-testid="val-new"><Plus className="h-4 w-4" /> Nuova valutazione</Btn>} />
      <Panel className="mb-4"><input className={inputCls} placeholder="Cerca per codice, proprietario, indirizzo…" value={q} onChange={(e) => setQ(e.target.value)} data-testid="val-search" /></Panel>
      <Panel><ul className="divide-y divide-border-subtle">{(list || []).map((v) => (
        <li key={v.id}><Link to={`/gestionale/valutazioni/${v.id}`} className="py-3 flex flex-wrap gap-3 items-center text-sm hover:bg-accent-subtle/40 rounded px-2" data-testid="val-row">
          <b>{v.codice}</b><span className="flex-1">{[v.immobile?.tipologia, v.immobile?.indirizzo, v.immobile?.comune].filter(Boolean).join(" · ") || "Immobile da descrivere"} {v.proprietarioNome && `· ${v.proprietarioNome}`}</span>
          {v.finale && <span>{fmtEuro(v.finale.centrale)}</span>}<span className="text-xs text-anthracite/50">v{v.versione} · {fmtDate(v.updatedAt)}</span><Badge tone={VAL_TONE[v.stato]}>{v.stato}</Badge></Link></li>))}
        {list && !list.length && <li className="py-4 text-sm text-anthracite/50">Nessuna valutazione.</li>}</ul></Panel>
      <NewDialog open={open} onClose={() => setOpen(false)} />
    </div>
  );
}
